import { render, staticRenderFns } from "./TestingofFrenchMiniStraw.vue?vue&type=template&id=e3f2d196&scoped=true&"
import script from "./TestingofFrenchMiniStraw.vue?vue&type=script&lang=js&"
export * from "./TestingofFrenchMiniStraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f2d196",
  null
  
)

export default component.exports